import { useBooking, useEvent, useTicketTypes } from '@/store';
import useAnalyticsEvents from './useAnalyticsEvents';
import {
  eventHasMerch,
  ticketHasMerch,
  eventHasMerchToShipping,
} from '@/config/onDemandMerchConfig';
import { useState, useEffect } from 'react';
import { usePaths } from '@/store';

export default function useMerch() {
  const [withMerch, setWithMerch] = useState(false);

  const { eneableStep } = usePaths();

  const { eventDetailPurchaseWithMerch, eventDetailPurchaseNoMerch } =
    useAnalyticsEvents();

  const {
    event: {
      event: { id },
    },
  } = useEvent();

  const { booking } = useBooking();

  useEffect(() => {
    if (booking?.orderInfo?.tickets) {
      let verifiedTiket = false;
      for (let i = 0; i < booking.orderInfo.tickets.length; i++) {
        if (ticketHasMerch(booking.orderInfo.tickets[i].ticket_type_name)) {
          verifiedTiket = true;
          break;
        }
      }
      setWithMerch(verifiedTiket);
    }
  }, [booking]);

  const ticketsWithMerchPurchased = booking?.orderInfo?.tickets.filter(
    (ticket) => ticketHasMerch(ticket.ticket_type_name),
  ).length;

  const sendMerchData = (tickets) => {
    const t = Object.values(tickets);
    const ticketsWithMerchPurchased = t.filter((ticket) =>
      ticketHasMerch(ticket.name),
    ).length;
    if (eventHasMerch(id) && ticketsWithMerchPurchased > 0) {
      eventDetailPurchaseWithMerch({
        tickets: t.length - ticketsWithMerchPurchased,
        withMerch: ticketsWithMerchPurchased,
      });
    } else {
      eventDetailPurchaseNoMerch({
        tickets: t.length,
        eventWithMerch: eventHasMerch(id),
      });
    }
  };

  const merchData = () => ({
    withMerch: booking?.orderInfo?.tickets.filter((ticket) =>
      ticketHasMerch(ticket.ticket_type_name),
    ).length,
    tickets: booking?.orderInfo?.tickets?.length,
  });

  useEffect(() => {
    if (eventHasMerchToShipping(id) && withMerch) {
      eneableStep('MERCH');
    }
  }, [withMerch]);

  return {
    isWithMerch: () =>
      (eventHasMerch(id) || eventHasMerchToShipping(id)) && withMerch,
    merchData,
    eventHasMerch,
    eventHasMerchToShipping,
    trigger: withMerch,
    sendMerchData,
  };
}
